import { MonoLabel } from '@/design-system';

/**
 * Browserchroom-mock boven de pagina. Alleen zichtbaar in de admin-preview:
 * het maakt duidelijk dat dit een echte publieke pagina is, geen bijlage.
 */
export function BrowserChrome({ url, secureLabel }: { url: string; secureLabel: string }) {
    return (
        <div
            aria-hidden="true"
            className="flex items-center gap-3 border-b border-[var(--placeholder-border)] bg-[var(--surface-chrome)] px-[14px] py-[10px]"
        >
            <div className="flex shrink-0 gap-[6px]">
                <span className="h-[10px] w-[10px] rounded-full bg-[var(--neutral-scrollbar)]" />
                <span className="h-[10px] w-[10px] rounded-full bg-[var(--neutral-scrollbar)]" />
                <span className="h-[10px] w-[10px] rounded-full bg-[var(--neutral-scrollbar)]" />
            </div>
            <div className="flex min-w-0 flex-1 items-center gap-2 rounded-[16px] border border-[var(--border-control)] bg-[var(--surface-card)] px-3 py-[7px]">
                <span className="shrink-0 text-[11px] leading-none text-[var(--accent-dark)]">
                    {secureLabel}
                </span>
                <MonoLabel size={11} variant="value" tone="default" className="truncate">
                    {url}
                </MonoLabel>
            </div>
        </div>
    );
}
